import { LoaderFunctionArgs } from "react-router";
import { AuthClient } from "../internal/AuthClient";

export async function loader({ request }: LoaderFunctionArgs) {
  const { searchParams } = new URL(request.url);
  const target = searchParams.get("referrer") || "/";

  await AuthClient.loginWithRedirect({ appState: { target } });
  return null;
}
